// BANNER PODS

jQuery(document).ready(function ($) {

  $(function () {
    $(".c-datepicker").datepicker();
  });
  
});
